
import * as Common from './action-type'
import {FRESHMENU, LIBRARYID} from "./action-type";

// 修改left-nav状态
export const collapsedToggle = (value)=>{
  return {
    type: Common.COLLAPSEDTOGGLE,
    value
  }
};

// 修改left-nav状态
export const setBreadcrumb = (value)=>{
  return {
    type: Common.SETBREADCRUMB,
    value
  }
};

// 修改reload状态
export const setReload = (value)=>{
  return {
    type: Common.RELOAD,
    value
  }
};

// 修改windowInfo
export const setWindowInfo = (value)=>{
  return {
    type: Common.WINDOWINFO,
    value
  }
};

// 修改登录用户信息
export const setUserInfo = (value)=>{
  return {
    type: Common.USERINFO,
    value
  }
};

// 修改登录用户信息
export const setMenu = (value)=>{
  return {
    type: Common.MENU,
    value
  }
};

// 选择年份
export const setYear= (value)=>{
  console.log(value);
  return {
    type: Common.YAER,
    value
  }
};

export const setHeaderYear= (value)=>{
  return {
    type: Common.headerYear,
    value
  }
};

// 选择添加的id
export const setIds = (value)=>{
  return {
    type: Common.IDS,
    value
  }
};


//修改选择的用户
export const setUserList = (value)=>{
  return {
    type: Common.USERLIST,
    value
  }
}

//修改选择的用户
export const setLibrary = (value)=>{
  return {
    type: Common.LIBRARYID,
    value
  }
}

//修改选择的用户
export const setLbname = (value)=>{
  return {
    type: Common.LIBRARYNAME,
    value
  }
}


// 切换主题
export const setCurrentTheme = (value)=>{
  return {
    type: Common.CURRENTTHEME,
    value
  }
};

// 切换菜单
export const refreshMenu = (value)=>{
  console.log(value,'action');
  return {
    type: Common.FRESHMENU,
    value
  }
};


export const setLibraryArr = (value)=>{
  return {
    type: Common.LIBRARYARR,
    value
  }
};



